"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var Observable_1 = require("rxjs/Observable");
var utilities_1 = require("../utilities");
var SaveCancelButtonGroupComponent = /** @class */ (function () {
    function SaveCancelButtonGroupComponent() {
        this.cancelEvent = new core_1.EventEmitter();
        this.saveEvent = new core_1.EventEmitter();
        this.saveCloseEvent = new core_1.EventEmitter();
    }
    SaveCancelButtonGroupComponent.prototype.onCancelEvent = function () {
        this.cancelEvent.emit();
    };
    SaveCancelButtonGroupComponent.prototype.onSaveEvent = function () {
        this.saveEvent.emit();
    };
    SaveCancelButtonGroupComponent.prototype.onSaveCloseEvent = function () {
        this.saveCloseEvent.emit();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SaveCancelButtonGroupComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], SaveCancelButtonGroupComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SaveCancelButtonGroupComponent.prototype, "systemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], SaveCancelButtonGroupComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SaveCancelButtonGroupComponent.prototype, "cancelEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SaveCancelButtonGroupComponent.prototype, "saveEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SaveCancelButtonGroupComponent.prototype, "saveCloseEvent", void 0);
    __decorate([
        utilities_1.CoolDown(300),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SaveCancelButtonGroupComponent.prototype, "onSaveEvent", null);
    __decorate([
        utilities_1.CoolDown(300),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SaveCancelButtonGroupComponent.prototype, "onSaveCloseEvent", null);
    SaveCancelButtonGroupComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'save-cancel-button',
            template: require('./save-cancel-button-group.component.html'),
            styles: [require('./save-cancel-button-group.component.scss')],
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n                    <save-cancel-button [id]=\"'%{id}'\" [entity]=\"%{entity}\" [systemName]=\"%{systemName}\"\n                        (cancelEvent)=\"%{cancelEvent}\" (saveEvent)=\"%{saveEvent}\" (saveCloseEvent)=\"%{saveCloseEvent}\">\n                    </save-cancel-button>\n      ",
        })
    ], SaveCancelButtonGroupComponent);
    return SaveCancelButtonGroupComponent;
}());
exports.SaveCancelButtonGroupComponent = SaveCancelButtonGroupComponent;
//# sourceMappingURL=save-cancel-button-group.component.js.map